export default function pdfMenu() {
  return {
    _id: false,
    type: 'droplet.pdfMenu',
    text: 'See Menu',
    newWindow: false,
    pdfLink: '#',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/pdf-menu/droplet.schema.js